import { createAction } from 'redux-actions';

import types from './types';

const _addSaga = createAction(types.ADD_SAGA);
const removeSaga = createAction(types.REMOVE_SAGA);
const _addReducer = createAction(types.ADD_REDUCER);
const removeReducer = createAction(types.REMOVE_REDUCER);
const afterAddReducer = createAction(types.AFTER_ADD_REDUCER);

const addSaga = (name, sagas, initAction) => _addSaga({ name, sagas, initAction });
const addReducer = (name, reducer) => _addReducer({ name, reducer });

export default {
    addReducer,
    removeReducer,
    addSaga,
    removeSaga,
    afterAddReducer,
};
